<template>
  <div>
    <a-input
      v-if="list.isEdit"
      :defaultValue="list[itemKey]"
      size="small"
      @change="handleChange"
    />
    <template v-else>{{ list[itemKey] }}</template>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Object,
    },
    itemKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      val: this.list[this.itemKey],
    }
  },
  methods: {
    getRowData() {
      return {
        [this.itemKey]: this.val,
      }
    },
    handleChange(e) {
      this.val = e.target.value
    },
  },
}
</script>
